import { Command } from 'commander';
import { Packager } from '../services/packager';
import { PackageManager, PackageOptions } from '../types';

export function createPackageCommand(): Command {
	const packager = new Packager();

	return new Command('package')
		.description('Package node_modules for AWS Lambda Layers')
		.option('-n, --name <name>', 'output file name', 'layer')
		.option(
			'-m, --package-manager <manager>',
			'package manager type',
			PackageManager.NPM,
		)
		.option(
			'-d, --directory <dir>',
			'target directory in archive',
			'nodejs/node_modules',
		)
		.option('--prod', 'include only production dependencies', true)
		.action(async (opts) => {
			try {
				const options: PackageOptions = {
					name: opts.name,
					directory: opts.directory,
					packageManager: opts.packageManager,
					productionOnly: opts.prod,
				};

				const result = await packager.package(options);
				console.log(`Successfully created ${result.fileName}`);
				console.log(`Packaged ${result.dependencies.length} dependencies`);
			} catch (error) {
				console.error('Failed to package dependencies:', error);
				process.exit(1);
			}
		});
}
